import { atom } from "jotai";
import _ from "lodash";
import { mbxUserAtom } from "./atoms";
import { selectedProviderIdAtom } from "./usersTable";
import uuid from "uuid/v4";
import { jsonParse, tableDateFormat } from "../utils";
import moment from "moment";

export const allBlockedTimesAtom = atom([]);
export const openBlockedTimeDialogAtom = atom(false);
export const groupedBlockedTimeRowsAtom = atom((get) =>
    _.groupBy(
        get(allBlockedTimesAtom).filter(({ scheduleinfo, providerId }) => {
            return (
                scheduleinfo.startsWith("BUT") &&
                providerId === get(selectedProviderIdAtom)
            );
        }),
        ({ scheduleinfo }) => scheduleinfo.split("|")[3]
    )
);

export const allBusAtom = atom((get) =>
    get(allBlockedTimesAtom).filter(({ scheduleinfo }) =>
        scheduleinfo.startsWith("BU|")
    )
);

const buByBuIdAtom = (buId) =>
    atom((get) =>
        get(allBusAtom).find(
            ({ scheduleinfo }) => scheduleinfo === `BU|${buId}`
        )
    );

export const displayBlockedTimesAtom = atom((get) => {
    return _.map(get(groupedBlockedTimeRowsAtom), (buts, buId) => ({
        buId,
        weekDays: buts[0].weekDays,
        dateRange: `${tableDateFormat(buts[0].startDate)} \u2014 ${tableDateFormat(buts[0].endDate)}`,
        startDate: buts[0].startDate,
        endDate: buts[0].endDate,
        MetaData: buts[0]?.MetaData,
        timeRange: buts
            ?.reduce((acc, { startTime, endTime }) => {
                const formattedStart = moment(startTime, "HH:mm").format(
                    "h:mm A"
                );
                const formattedEnd = moment(endTime, "HH:mm").format("h:mm A");

                if (
                    formattedStart === "12:00 AM" &&
                    formattedEnd === "11:59 PM"
                ) {
                    return "All day";
                }
                if (formattedEnd === "11:59 PM") {
                    return `${acc} ${formattedStart} \u2014 Midnight`;
                }

                return `${acc} ${formattedStart} \u2014 ${formattedEnd}`;
            }, "")
            .trim(),

        notes:
            jsonParse(
                get(buByBuIdAtom(buId))?.notes,
                [""],
                "Error parsing blocked time notes"
            )?.[0] || ""
    }));
});
export const selectedBuIdAtom = atom();
export const blockedTimeFormDataAtom = atom((get) => {
    const buId = get(selectedBuIdAtom);
    if (buId) {
        const timeBlocks = get(groupedBlockedTimeRowsAtom)[buId];
        if (!timeBlocks) return undefined;
        return {
            buId,
            weekDays: timeBlocks[0].weekDays,
            weeksToRepeat: timeBlocks[0].weeksToRepeat,
            startDate: timeBlocks[0].startDate,
            endDate: timeBlocks[0].endDate,
            timeBlocks: timeBlocks.map(({ startTime, endTime, ...rest }) => ({
                startTime: Date.prototype.setHours.apply(
                    new Date(),
                    startTime.split(":")
                ),
                endTime: Date.prototype.setHours.apply(
                    new Date(),
                    endTime.split(":")
                ),
                ...rest
            })),
            notes:
                jsonParse(
                    get(buByBuIdAtom(buId))?.notes,
                    [""],
                    "Error parsing blocked time notes"
                )?.[0] || ""
        };
    } else return undefined;
});
export const recordIdAtom = atom((get) => {
    const { companyId } = get(mbxUserAtom);
    const providerId = get(selectedProviderIdAtom);
    return `C-${companyId}|P-${providerId}`;
});
export const scheduleInfoAtom = atom((get) => {
    const startTime = new Date().setHours(9, 0, 0, 0);
    const endTime = new Date().setHours(17, 0, 0, 0);
    return () =>
        `BUT|${startTime} ${endTime}|${uuid()}|BU|${get(selectedBuIdAtom)}`;
});

export const onlyCurrentBlockedTimesAtom = atom((get) => {
    const displayBlockedTimeRows = get(displayBlockedTimesAtom);
    return (displayBlockedTimeRows || []).filter(
        (block) => block.endDate >= moment().format("YYYY-MM-DD")
    );
});
